import { KeyValueList, type KeyValueItem } from '@vigeo/ui';
import type { Person } from '@vigeo/shared';
import { CandidateIntakeCard } from '../CandidateIntakeCard.js';
import { PersonDetailsPanel } from '../PersonDetailsPanel.js';
import { TriggerInputsCard } from './TriggerInputsCard.js';
import { usePersonStyles } from './styles.js';

/** Step 6. Moved unchanged from `pages/PersonPage.tsx` (#462 §5). */
export interface ProfileStepProps {
  readonly person: Person;
  readonly canEdit: boolean;
  readonly details: readonly KeyValueItem[];
  readonly openTriggerInputs: boolean;
}

export function ProfileStep({ person, canEdit, details, openTriggerInputs }: ProfileStepProps) {
  const styles = usePersonStyles();
  return <div className={styles.page}>
    <section className={styles.card} aria-label="Details"><KeyValueList items={[...details]} aria-label="Person details" /></section>
    <PersonDetailsPanel person={person} canEdit={canEdit} />
    <CandidateIntakeCard person={person} />
    <TriggerInputsCard person={person} canEdit={canEdit} openForLink={openTriggerInputs} />
  </div>;
}
